import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "relative mb-16" }
const _hoisted_5 = ["value", "max"]
const _hoisted_6 = { class: "relative aspect-square w-44 rounded-circle border border-black-200 bg-white" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return ($props.cartHasItems && $props.isCountryAvailable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["text-center text-14 font-medium text-black-900", {'mb-16': !$props.isShippingAmountReached}])
        }, [
          (!$props.isShippingAmountReached)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.shippingAmountLeft) + " " + _toDisplayString($props.locale.shipping_text_progress), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.locale.shipping_text_reached), 1))
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("progress", {
            value: $props.total,
            max: $props.formattedShippingThreshold,
            class: "w-full align-middle transition-all duration-500"
          }, null, 8, _hoisted_5),
          _withDirectives(_createElementVNode("div", {
            class: "center-y absolute",
            style: _normalizeStyle(`left: ${$props.shippingFollowerPosition}`)
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_icon, {
                icon: "truck",
                width: 24,
                height: 24,
                class: "center-center absolute"
              })
            ])
          ], 4), [
            [_vShow, !$props.isShippingAmountReached]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}